import styled from '@react-pdf/styled-components';
import { ContainerRadius } from '../styles';

export const ContainerPhotos = styled(ContainerRadius)`
  width: 100%;
  height: 650px;
  padding: 20px;
  margin: 30px 0;
`;

export const WrapperPhotos = styled.View`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: space-between;
  /* align-items: center; */
  width: 100%;
  margin: 0;
`;

export const PhotoWrapper = styled.View`
  width: ${({ aspectRatio, height }) => (aspectRatio && height ? `${aspectRatio * height}px` : '159px')};
  height: ${({ height }) => (`${height}px` || '159px')};
  margin: 7px;
  flex-grow: 0;
`;

export const Photo = styled.Image`
  flex-grow: 1;
  object-fit: contain;
`;
